import React from "react";
import {useHistory, useLocation} from "react-router-dom";

import Router from "router/router";

import * as Api from "api/api";
import * as antd from "antd";
import {Form} from "antd";
import * as glx from "components/glx";
import * as cssInJs from "./css/login-form";
import {observer} from "mobx-react";
import useMyStores from "@/hooks/useMyStores";
import * as css from './css/loginForm.module.scss'

const LoginForm = ({className}) => {
    const history = useHistory();
    const location = useLocation();

    const {login: store, user} = useMyStores()

    const [form] = antd.Form.useForm()

    const onFinish = async (values) => {
        try {
            await Api.login(values);

            antd.message.success("登录成功");
            // await user.login();
            if (location.pathname === Router.Login.path) {
                toHome()
            } else {
                store.show = false;
            }
        } catch (error) {
        } finally {
        }
    }


    const toRegister = () => {
        history.replace({
            pathname: Router.Register.path
        });
    };

    const toHome = () => {
        history.replace({
            pathname: Router.Home.path
        });
    }

    const formInitialValues = {
        username: '',
        password: ''
    }

    return (
        <cssInJs.LoginForm className={className}>
            <cssInJs.BgImg src={require("./img/bg.png")}/>
            <cssInJs.TitleFloor>
                <cssInJs.TitleText src={require("./img/title-text.png")}/>
                <cssInJs.TitleBgImg src={require("./img/title-bg.png")}/>
            </cssInJs.TitleFloor>

            <Form className={css.antLoginForm} initialValues={formInitialValues} onFinish={onFinish} form={form}>
                <Form.Item className={css.formItem}>
                    <cssInJs.InputIcon src={require("./img/username-icon.png")}/>
                    <cssInJs.BgImg src={require("./img/input-img.png")}/>
                    <Form.Item
                        noStyle
                        name={['username']}
                        rules={[
                            {
                                required: true,
                                message: "请输入用户名"
                            }
                        ]}
                    >
                        <input
                            className={css.input}
                            placeholder="用户名/邮箱/手机号"
                        />
                    </Form.Item>
                </Form.Item>
                <Form.Item className={css.formItem}>
                    <cssInJs.InputIcon src={require("./img/password-icon.png")}/>
                    <cssInJs.BgImg src={require("./img/input-img.png")}/>
                    <Form.Item
                        noStyle
                        name={['password']}
                        rules={[
                            {
                                required: true,
                                message: "请输入密码"
                            }
                        ]}
                    >
                        <input
                            className={css.input}
                            type="password"
                            placeholder="密码"
                        />
                    </Form.Item>
                </Form.Item>
                <cssInJs.SaveBlock>
                    <glx.Checkbox id="save-checkbox" checked/>
                    <cssInJs.SaveText>保存我的登录信息</cssInJs.SaveText>
                    <cssInJs.RegisterText onClick={toRegister}>
                        前往注册
                    </cssInJs.RegisterText>
                    <cssInJs.RegisterIcon
                        src={require("./img/register-icon.png")}
                        onClick={toRegister}
                    />
                </cssInJs.SaveBlock>
                <cssInJs.LoginButton>
                    <cssInJs.BgImg src={require("./img/login-bg.png")}/>
                    登录
                </cssInJs.LoginButton>
            </Form>
        </cssInJs.LoginForm>
    );

}

export default observer(LoginForm);


